import './take-attendance.scss';
//library
import format from 'date-fns/format';
import es from 'date-fns/locale/es';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { useRef } from 'react';
//shared
import ICalendar from '../shared/interfaces/calendar.interface';
import { ATTENDANCE_TAKED, MODIFY_NAME_ZOOM, RESERVES_BY_CALENDAR } from '../shared/graphql/branch';
import { InputButton } from '../shared/components/input-button/input-button';
import { BUTTON } from './constants/button';
import { TEXTFIELD } from './constants/text-field';
import Message from '../shared/components/message/message';
import { MESSAGE } from './constants/messages';
import { SkeletonTable } from '../shared/components/skeleton-table/skeleton-table';
//material
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, IconButton, Grid } from '@mui/material';

function createCol(
    name: string
) {
    return { name };
}

let rows: { id: number, names: string; surnames: string; status: number, virtual: boolean; }[] = [];

let cols = [createCol('Nombre'), createCol('Estado de asistencia')];

function PushTakeAttendance({ reserveId, messageActivated }: { reserveId: number, messageActivated: (response: {message: string, success: boolean}) => void }) {
    const [takeAttendanceMutation, { data, loading, error, reset }] = useMutation(ATTENDANCE_TAKED);

    if (data && data.attendanceClassStudio) {
        messageActivated(data.attendanceClassStudio);
        reset();
    };
    if (loading) return <CircularProgress size={25} />;
    if (error) console.log(`Submission error! ${error.message}`);

    const takeAttendance = (identification: string | number) => {
        takeAttendanceMutation({
            variables: {
                bookId: reserveId,
                idCardUser: identification,
                originWeb: true,
            },
        });
    }

    return (
        <>
            <InputButton buttonData={BUTTON} textFieldData={TEXTFIELD} buttonClick={(data: string | number) => takeAttendance(data)}></InputButton>
        </>
    );
}

function DataTable({ calendarId }: { calendarId: number }) {
    let message = MESSAGE;
    message.open = useRef<any>(null);
    rows = [];

    const { loading, error, data, refetch } = useQuery(RESERVES_BY_CALENDAR, {
        variables: { calendarId: calendarId },
    });

    if (loading) return <SkeletonTable></SkeletonTable>;
    if (error) console.log(`Submission error! ${error.message}`);

    data.reservationsByCalendar.forEach((el: any) => {
        rows.push({ id: el.id, names: el.user.names, surnames: el.user.surnames, status: el.status.id, virtual: el.calendar.classFit.virtual });
    })

    const showMessage = (response: {message: string, success: boolean}) =>{
        message.textMessage = response.message;
        message.style = response.success ? 'success':'danger';
        setTimeout(() => {
            message.open.current.show();
        }, 500);
        refetch();
    }

    const statusText = (id:number, virtual:boolean,status:number) => {
        console.log("ID", id)
        if(!virtual && (status === 1 || status === 7)){
            return <PushTakeAttendance reserveId={id} messageActivated={(ev) => showMessage(ev)}></PushTakeAttendance>;
        }else if(virtual && (status === 1 || status === 7)){
            return 'Reservada';
        }else if(status === 2){
            return 'Tomada';
        }else if(status === 5){
            return 'Cancelado';
        }else if(status === 3){
            return 'Cancelado tarde';
        }else if(status === 4){
            return 'No show';
        }
        return <></>
    }

    return (
        <>
            <TableContainer className='container-attendance' component={Paper}>
                <Table sx={{ minWidth: 250 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {cols.map((col) => (
                                <TableCell key={col.name} align="center">{col.name}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align="center" component="th" scope="row">
                                    {row.names} {row.surnames}
                                </TableCell>

                                <TableCell align="center">
                                    {statusText(row.id, row.virtual, row.status)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Message data={message} ref={message.open} />
        </>
    );
}

export default function TakeAttendance({ attendance, dataCalendar }: { attendance: () => void, dataCalendar: ICalendar}) {
    const [modifyName] = useLazyQuery(MODIFY_NAME_ZOOM);
    console.log(dataCalendar);
    const zoomResponse = (zoomResponseLink : any, flag: any) => {
        modifyName({ variables: { zoomId: zoomResponseLink.id }});
        if(flag && zoomResponseLink.zoom_host_link){
            window.open(zoomResponseLink.zoom_host_link,"_blank");
        }else{
            window.open(zoomResponseLink.zoom_link,"_blank");
        }
    }

    const openLink = () => {
        zoomResponse(dataCalendar.virtualClass, dataCalendar.classFit.branch.host_admin);
    }

    return (
        <Box>
            <div className='container-body'>
                <h1>Asistencia Pendiente</h1>
            </div>
            <Grid container>
                <Grid item xs={8} className='container-body'>
                    <IconButton onClick={() => attendance()}>
                        <ArrowBackIcon />
                    </IconButton>
                    <h2>{dataCalendar.classFit.name}</h2>
                    <h3>{format(new Date(dataCalendar.start), "dd 'de' MMMM 'de' yyyy", { locale: es })}</h3>
                    <h4>{format(new Date(dataCalendar.start), "HH:mm")}</h4>
                </Grid>
                {(dataCalendar.virtualClass && dataCalendar.virtualClass.zoom_link) && (
                    <Grid item xs={4} className='container-link'>
                        <a href={dataCalendar.virtualClass.zoom_link} target="_blank" rel="noopener noreferrer" onClick={openLink}>Link de la clase</a>
                    </Grid>
                )}
            </Grid>
            <DataTable calendarId={dataCalendar.id}></DataTable>
        </Box>
    );
}